import React from 'react'
import AopsCommonModalLayout from '../../components/apos/modal/AopsCommonModalLayout'
import InitiativeKanbanBoard from './InitiativeKanbanBoard'
import './initiativeKanbanBoard.scss'

/**
 * Objective 상세 팝업
 * InitiativeKanbanBoard 전체(헤더 + Initiative 업무 생성 버튼 + 칸반 컬럼)를 모달 안에 표시
 *
 * @param {boolean} open - 팝업 열림 여부
 * @param {Function} onClose - 팝업 닫기
 * @param {Object} objective - Objective 데이터 (id, title, sequence, initiativesByCategory 등)
 * @param {string} objectiveNumber - 표시용 번호 (예: "01")
 * @param {string} objectiveTitle - Objective 제목
 * @param {Object} tasksByCategory - 카테고리별 Initiative 목록
 * @param {Function} onTaskClick - Initiative 카드 클릭 시 (STORY 팝업 열기용)
 * @param {Function} onCreateClick - Initiative 업무 생성 버튼 클릭 시
 * @param {Function} onObjectiveClick - 상세 보기 클릭 시 (Objective/EPIC 수정·삭제용 BoardWorkPopup 열기)
 * @param {boolean} showCreateButton - 생성 버튼 표시 여부
 */
const ObjectiveDetailPopup = ({
  open,
  onClose,
  objective,
  objectiveNumber = '01',
  objectiveTitle = '',
  tasksByCategory = {},
  onTaskClick,
  onCreateClick,
  onObjectiveClick,
  showCreateButton = true,
  zIndex,
}) => {
  if (!objective) return null

  return (
    <AopsCommonModalLayout
      open={open}
      onClose={onClose}
      title={`${objectiveNumber}. Objective - ${objectiveTitle}`}
      width="90%"
      contentStyle={{ padding: '32px', margin: 0, boxSizing: 'border-box' }}
      contentClassName="objective-detail-popup-content"
      zIndex={zIndex || 1000} // 기본 z-index (Antd 기본값과 동일)
    >
      <InitiativeKanbanBoard
        objective={objective}
        objectiveNumber={objectiveNumber}
        objectiveTitle={objectiveTitle}
        tasksByCategory={tasksByCategory}
        onTaskClick={onTaskClick}
        onCreateClick={onCreateClick}
        onObjectiveClick={onObjectiveClick ?? onClose}
        showCreateButton={showCreateButton}
      />
    </AopsCommonModalLayout>
  )
}

export default ObjectiveDetailPopup
